<template>
  <div id="maintenancePartsFilters" class="maintenance-parts-filters columns">
    <div class="column filter">
      <label for="part_number">Part Number</label>
      <div class="part-number-search">
        <input type="text" v-model="partNumberSearchFilter" id="part_number" placeholder="Enter Part Number">
        <button type="button"><span class="material-icons" data-localizer="ignore">search</span></button>
      </div>
    </div>
    <div class="column filter separator is-narrow-tablet">
      <strong>or</strong>
    </div>
    <div class="column filter">
      <label for="series_id">Series</label>
      <select v-model="seriesSearchFilter" :id="series_id">
        <option value="">Select a Connector Series</option>
        <option v-for="(series) in seriesOptions" :key="series.id" :value="series.id">{{ series.name }}</option>
      </select>
    </div>
    <div class="column filter">
      <label for="size">Size</label>
      <select v-model="sizeSearchFilter" :id="size" :disabled="seriesSearchFilter === ''">
        <option value="">Select a Connector Size</option>
        <option v-for="(size) in sizeOptions" :key="size" :value="size">{{ size }}</option>
      </select>
    </div>
  </div>
</template>

<script>
import { useModelWrapper } from '@/utils/modelWrapper'

export default {
  name: 'MaintenancePartsSearchFilters',
  props: {
    seriesOptions: Array,
    sizeOptions: Array,
    partNumberFilter: String,
    seriesFilter: String,
    sizeFilter: String
  },
  setup (props, { emit }) {
    return {
      partNumberSearchFilter: useModelWrapper(props, emit, 'partNumberFilter'),
      seriesSearchFilter: useModelWrapper(props, emit, 'seriesFilter'),
      sizeSearchFilter: useModelWrapper(props, emit, 'sizeFilter')
    }
  }
}
</script>
